const getters = {
    donationCart: state => state.donationCart,
    productDonationStatus: state => state.productDonationStatus,
    productDonationErrors: state => state.productDonationErrors,
    donationErrors: state => state.donationErrors,
    donationTotal: state => state.donationTotal,
};

export default getters;
